// Author Lin
// Date 2022-07-21 17:25:40

class SithMesInventoryChangeProjectDetail {
        constructor({
                id = null,
                changeId = '',
                materialNumber = '',
                changeQuantity = '',
                binCode = '',
                specialStock = '',
                specialStockNumber = '',
                plant = '',
                storageType = '',
                storageLocation = '',
                unit = '',
                sendSapStatus = '',
                batchNumber = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.changeId = changeId;
            this.materialNumber = materialNumber;
            this.changeQuantity = changeQuantity;
            this.binCode = binCode;
            this.specialStock = specialStock;
            this.specialStockNumber = specialStockNumber;
            this.plant = plant;
            this.storageType = storageType;
            this.storageLocation = storageLocation;
            this.unit = unit;
            this.sendSapStatus = sendSapStatus;
            this.batchNumber = batchNumber;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesInventoryChangeProjectDetail();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'changeId',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.changeId',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'materialNumber',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.materialNumber',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'changeQuantity',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.changeQuantity',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'binCode',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.binCode',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'specialStock',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.specialStock',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'specialStockNumber',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.specialStockNumber',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'plant',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.plant',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'storageType',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.storageType',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'storageLocation',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.storageLocation',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'unit',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.unit',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'changeType',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.changeType',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'SO转SO' },
                                    { value: '2', text: 'WBS转SO' },
                                    { value: '3', text: 'SO转大库' },
                                    { value: '4', text: '大库转SO' },
                                    { value: '5', text: '大库转WBS' },
                                    { value: '6', text: '寄售转大库' },
                                    { value: '7', text: 'WBS转大库' },
                                    { value: '8', text: 'SO转WBS' },
                                    { value: '9', text: 'WBS转WBS' },
                                    { value: '10', text: '大库转供应商' }
                    ]
                }
                },
                {
                key: 'target',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.target',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'sendSapStatus',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.sendSapStatus',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '0', text: '成功' },
                                    { value: '1', text: '失败' },
                                    { value: '2', text: '其他' }
                    ]
                }
                },
                {
                key: 'batchNumber',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.batchNumber',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            changeIdFilter : '',
            materialNumberFilter : '',
            changeQuantityFilter : '',
            binCodeFilter : '',
            specialStockFilter : '',
            specialStockNumberFilter : '',
            plantFilter : '',
            storageTypeFilter : '',
            storageLocationFilter : '',
            unitFilter : '',
            sendSapStatusFilter : '',
            batchNumberFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'changeIdFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.changeId',
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialNumberFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.materialNumber',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'changeQuantityFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.changeQuantity',
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'binCodeFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.binCode',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'specialStockFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.specialStock',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'specialStockNumberFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.specialStockNumber',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'plantFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.plant',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'storageTypeFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.storageType',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'storageLocationFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.storageLocation',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'unitFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.unit',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'sendSapStatusFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.sendSapStatus',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '0', text: '成功' },
                        { value: '1', text: '失败' },
                        { value: '2', text: '其他' }
                    ]
                }
                },
                {
                key: 'batchNumberFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.filter.batchNumber',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'changeId',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.changeId',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialNumber',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.materialNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'changeQuantity',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.changeQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'binCode',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.binCode',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'specialStock',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.specialStock',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'specialStockNumber',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.specialStockNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'plant',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.plant',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'storageType',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.storageType',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'storageLocation',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.storageLocation',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'unit',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.unit',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'sendSapStatus',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.sendSapStatus',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '0', text: '成功' },
                        { value: '1', text: '失败' },
                        { value: '2', text: '其他' }
                    ]
                }
                },
                {
                key: 'batchNumber',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.batchNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryChangeProjectDetail.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                        }
                }
        ]
        
        export {SithMesInventoryChangeProjectDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        